import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import { installDebugCapture } from '@/lib/issue-reporting/debugBuffer';
import '@/styles/globals.css';

// Hook console/window error capture for the "Report an issue" diagnostics. Runs once, app-wide.
installDebugCapture();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element '#root' not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
